import React from "react";
import { useIntl } from "react-intl";
import type { FC } from "react";

import { useDialogActions } from "../../../common";

import { SubscriptionsDialog } from "../SubscriptionsDialog";
import { ISavedSubscriptionDialogProps } from "./SavedSubscriptionDialog.types";
import messages from "./SavedSubscriptionDialog.messages";

export const SavedSubscriptionDialog: FC<ISavedSubscriptionDialogProps> = (props) => {
  const { formatMessage } = useIntl();
  const { dismiss } = useDialogActions();

  return (
    <SubscriptionsDialog
      title={messages.title}
      contentText={formatMessage(messages.message)}
      actions={[{ name: messages.confirm }]}
      alignActions="center"
      open={true}
      handleCloseDialog={dismiss}
    />
  );
};
